module.exports = __webpack_public_path__ + "media/images/icons/cbi2-84af9b8bf30b348e72954a2eb6a66a6a.svg";